import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterOfBenefactorsComponent } from './register-of-benefactors.component';
import { SharedModule } from '../../shared/shared.module';
import { MatTableModule, MatProgressSpinnerModule, MatSelectModule } from '@angular/material';
import { ExtractService } from '../extract/extract.service';
import { RegisterOfBenefactorsService } from './register-of-benefactors.service';
import { TableDetailDataSource } from '../../utils/table-detail-data-source';
import { AddBenefactorsComponent } from './add-benefactors/add-benefactors.component';
import { ListBenefactorsComponent } from './list-benefactors/list-benefactors.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from '../../app-routing.module';
import { CdkTableModule } from '@angular/cdk/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TextMaskModule } from 'angular2-text-mask';
import { BenefactorDataComponent } from './add-benefactors/benefactor-data/benefactor-data.component';
import { BenefactorConfirmationComponent } from './add-benefactors/benefactor-confirmation/benefactor-confirmation.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		MatTableModule,
		HttpClientModule,
		MatProgressSpinnerModule,
		FormsModule,
		ReactiveFormsModule,
		AppRoutingModule,
		CdkTableModule,
		MatAutocompleteModule,
		MatSelectModule,
		TextMaskModule
	],
	declarations: [
		RegisterOfBenefactorsComponent,
		AddBenefactorsComponent,
		ListBenefactorsComponent,
		BenefactorDataComponent,
		BenefactorConfirmationComponent
	],
	exports: [
		RegisterOfBenefactorsComponent,
		MatTableModule,
		CdkTableModule
	],
	providers: [
		RegisterOfBenefactorsService,
		TableDetailDataSource
	]
})
export class RegisterOfBenefactorsModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/register-of-benefactors/register-of-benefactors.module.ts